import React, { useState, useEffect, useRef, useCallback } from 'react';
import { trackImageGalleryView, trackEvent } from '../firebase';

// Importar las imágenes
import efimero from '../assets/Lis_Efimero 01.webp';
import efimero2 from '../assets/Lis_Efimero 02.webp';
import efimeroModelo1 from '../assets/Lis-modelo_Efimero 01.webp';
import efimeroModelo2 from '../assets/Lis-modelo_Efimero 02.webp';
import efimeroModelo3 from '../assets/Lis-modelo_Efimero 03.webp';

import deluxe from '../assets/Lis_Deluxe 01.webp';
import deluxe2 from '../assets/Lis_Deluxe 02.webp';
import deluxeModelo2 from '../assets/Lis-modelo_Deluxe 02.webp';
import deluxeModelo3 from '../assets/Lis-modelo_Deluxe 03.webp';

import liliums from '../assets/Lis_Ramo liliums 01.webp';
import liliums2 from '../assets/Lis_Ramo liliums 02.webp';
import liliumsModelo1 from '../assets/Lis-modelo_Ramo liliums 01.webp';
import liliumsModelo2 from '../assets/Lis-modelo_Ramo liliums 02.webp';

// Nuevos ramos
import greenHope from '../assets/Lis_Green hope.webp';
import greenHopeModelo1 from '../assets/Lis-modelo_Green hope 01.webp';
import greenHopeModelo2 from '../assets/Lis-modelo_Green hope 02.webp';
import greenHopeModelo3 from '../assets/Lis-modelo_Green hope 03.webp';
import greenHopeModelo4 from '../assets/Lis-modelo_Green hope 04.webp';

import tropico from '../assets/Lis_Bienvenido bebe grande.webp';
import tropicoModelo1 from '../assets/Lis-modelo_Bienvenido bebe grande 01.webp';
import tropicoModelo2 from '../assets/Lis-modelo_Bienvenido bebe grande 03.webp';

import stylish from '../assets/Lis_Bienvenido bebe pequeno.webp';
import stylishModelo1 from '../assets/Lis-modelo_Bienvenido bebe pequeno 01.webp';
import stylishModelo2 from '../assets/Lis-modelo_Bienvenido bebe pequeno 02.webp';

import brisa from '../assets/BRISA.webp';

// Ramos para eventos
import madreSelva from '../assets/Lis_Ramo selva.webp';
import mareaVerde from '../assets/Lis_Ramo verde hotel G.webp';

// Nuevos productos de eventos
import esculturaGrande from '../assets/Lis_Escultura de flores grande.webp';
import esculturaClavel from '../assets/Lis_Escultura de flores pequena - clavel.webp';
import esculturasPequena1 from '../assets/Lis_Escultura de flores pequena 01.webp';
import esculturasPequena2 from '../assets/Lis_Escultura de flores pequena 02.webp';
import violeteros from '../assets/Lis_Violeteros flor suelta.webp';
import cymbidiumGrande from '../assets/Lis_Ramo cymbidium hotel G.webp';
import cymbidiumPequeno from '../assets/Lis_Ramo cymbidium hotel P.webp';
import cymbidiumVerde from '../assets/Lis-black_Cymbidium verde.webp';

// Productos de nacimientos
import bebeGrande from '../assets/Lis_Bienvenido bebe grande.webp';
import bebeGrandeModelo1 from '../assets/Lis-modelo_Bienvenido bebe grande 01.webp';
import bebeGrandeModelo3 from '../assets/Lis-modelo_Bienvenido bebe grande 03.webp';
import muselinaBebe from '../assets/Lis_Muselina bebe.webp';
import bebePequeno from '../assets/Lis-modelo_Bienvenido bebe pequeno 01.webp';
import bebePequenoModelo2 from '../assets/Lis-modelo_Bienvenido bebe pequeno 02.webp';

// Productos románticos
import velvet from '../assets/Lis-modelo_Velvet 03.webp';
import velvetModelo1 from '../assets/Lis-modelo_Velvet 01.webp';
import velvetModelo2 from '../assets/Lis-modelo_Velvet 02.webp';
import rosaBlanca from '../assets/Lis-modelo_Rosa blanca 01.webp';
import rosaBlancaModelo2 from '../assets/Lis-modelo_Rosa blanca 02.webp';
import rosaBlancaModelo3 from '../assets/Lis-modelo_Rosa blanca 03.webp';
import rosaBlancaModelo4 from '../assets/Lis-modelo_Rosa blanca 04.webp';
import ramoRosas from '../assets/RamoRosas.webp';
import ramoSeco from '../assets/Lis_Ramo seco.webp';
import ramoSecoPreservado from '../assets/Lis_Ramo seco y preservado.webp';

// Plantas
import orquidea1 from '../assets/Lis_Orquideas 01.webp';
import orquidea2 from '../assets/Lis_Orquideas 02.webp';

const Gallery = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('sorprender');
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [inViewItems, setInViewItems] = useState(new Set());
  const galleryItemsRef = useRef([]);

  const categories = [
    { id: 'sorprender', name: 'Para Sorprender' },
    { id: 'eventos', name: 'Eventos Especiales' },
    { id: 'nacimientos', name: 'Nacimientos' },
    { id: 'romanticos', name: 'Románticos' },
    { id: 'plantas', name: 'Plantas' }
  ];

  const projects = [
    {
      id: 1,
      title: "Efímero",
      subtitle: "Ramo colorido de flores variadas. Perfecto para una celebración.",
      image: efimero,
      description: "Ramo colorido de flores variadas. Perfecto para una celebración.",
      modalDescription: "Perfecto para dar alegría a tus seres queridos. Con una mezcla de colores y de flores que pueden variar según la temporada del año.",
      price: "38€",
      category: "sorprender",
      imagenesSlider: [efimero, efimero2, efimeroModelo1, efimeroModelo2, efimeroModelo3]
    },
    {
      id: 2,
      title: "Ramo Deluxe",
      subtitle: "Delicado y elegante",
      image: deluxe,
      description: "Delicado y elegante",
      modalDescription: "La persona que lo reciba se quedara sin palabras.",
      price: "45.50€",
      category: "sorprender",
      imagenesSlider: [deluxe, deluxe2, deluxeModelo2, deluxeModelo3]
    },
    {
      id: 3,
      title: "Ramo de Liliums",
      subtitle: "Impregnarán tu casa de un olor que amarás",
      image: liliums,
      description: "Impregnarán tu casa de un olor que amarás",
      modalDescription: "Su duración dependerá de la temperatura y el cuidado que le des. Recuerda que son seres vivos y les afecta la temperatura del ambiente. Recomendamos cortar unos centímetros los tallos y cambiar el agua cada tres días. El ramo presenta flores abiertas y cerradas para que puedas disfrutar de ellas y observar cómo el ramo va evolucionando según pasan los días.",
      price: "35€",
      category: "sorprender",
      imagenesSlider: [liliums, liliums2, liliumsModelo1, liliumsModelo2]
    },
    {
      id: 4,
      title: "Green hope",
      subtitle: "El verde esperanza nos levanta el ánimo en esos momentos difíciles de la vida",
      image: greenHope,
      description: "El verde esperanza nos levanta el ánimo en esos momentos difíciles de la vida",
      modalDescription: "Transmite apoyo, confianza o promesa. Este ramo contiene flores diferentes para dar un toque de optimismo e ilusión. Sus flores verdes y blancas nos dan una perspectiva singular.",
      price: "37.09€",
      category: "sorprender",
      imagenesSlider: [greenHope, greenHopeModelo1, greenHopeModelo2, greenHopeModelo3, greenHopeModelo4]
    },
    {
      id: 5,
      title: "Trópico",
      subtitle: "Mezcla de flores tropicales",
      image: tropico,
      description: "Mezcla de flores tropicales",
      modalDescription: "Ramo alegre que vamos variando según la temporada y que juntas crean este arreglo tan singular.",
      price: "45.51€",
      category: "sorprender",
      imagenesSlider: [tropico, tropicoModelo1, tropicoModelo2]
    },
    {
      id: 6,
      title: "Stylish",
      subtitle: "Ramo elegante perfecto para cualquier ocasión",
      image: stylish,
      description: "Ramo elegante perfecto para cualquier ocasión",
      modalDescription: "Contiene flores bonitas y raras de temporada.",
      price: "32.50€",
      category: "sorprender",
      imagenesSlider: [stylish, stylishModelo1, stylishModelo2]
    },
    {
      id: 7,
      title: "Brisa",
      subtitle: "Ramo premium",
      image: brisa,
      description: "Ramo premium",
      modalDescription: "Rosas Garden y flores variadas según la temporada.",
      price: "55.35€",
      category: "sorprender",
      imagenesSlider: [brisa]
    },
    {
      id: 8,
      title: "Madre Selva",
      subtitle: "Destacará e impactará a tus clientes",
      image: madreSelva,
      description: "Destacará e impactará a tus clientes",
      modalDescription: "Este arreglo floral de gran formato fue creado con la intención de llamar la atención y dar la sensación de frescura.",
      price: "Desde 70€",
      category: "eventos",
      imagenesSlider: [madreSelva]
    },
    {
      id: 9,
      title: "Marea verde",
      subtitle: "Diseño elegante y sofisticado",
      image: mareaVerde,
      description: "Diseño elegante y sofisticado",
      modalDescription: "Perfecto para la recepción de invitados y clientes, ya sea en tu hotel, oficina o en una celebración especial.",
      price: "Desde 69€",
      category: "eventos",
      imagenesSlider: [mareaVerde]
    },
    {
      id: 10,
      title: "Escultura",
      subtitle: "Arte Floral",
      image: esculturaGrande,
      description: "Arte Floral",
      modalDescription: "Podemos esculpir crear y dar formas y texturas para transportar jardines a nuestras mesas.",
      price: "Desde 84€",
      category: "eventos",
      imagenesSlider: [esculturaGrande]
    },
    {
      id: 11,
      title: "Clavel",
      subtitle: "Flores con un toque artístico",
      image: esculturaClavel,
      description: "Flores con un toque artístico",
      modalDescription: "Las flores y los colores pueden variar según la temporada en la que estemos, recuerda que trabajamos con elementos que estan vivos, magía de la naturaleza nos da la opción de tener flores diferentes durante todo el año.",
      price: "Desde 41€",
      category: "eventos",
      imagenesSlider: [esculturaClavel]
    },
    {
      id: 12,
      title: "Esculturas florales",
      subtitle: "Diferentes texturas",
      image: esculturasPequena1,
      description: "Diferentes texturas",
      modalDescription: "Si estas buscando sorprender totalmente a alguien, con estos diseños seguro que lo consigues.",
      price: "Desde 64€",
      category: "eventos",
      imagenesSlider: [esculturasPequena1, esculturasPequena2]
    },
    {
      id: 13,
      title: "Violeteros",
      subtitle: "Flores delicádas según la ocasión",
      image: violeteros,
      description: "Flores delicádas según la ocasión",
      modalDescription: "¿Tienes un evento y quieres vestir tus mesas con flores bonitas para dar un toque elegante a tu celebración y sorprender a tus invitados? Recuerda que la naturaleza viva nos da muchos tipos de flores y que puedes elegir entre una amplia gama de colores según la temporada.",
      price: "Desde 41€",
      category: "eventos",
      imagenesSlider: [violeteros]
    },
    {
      id: 14,
      title: "Cymbidium",
      subtitle: "Sobria pero con caracter",
      image: cymbidiumGrande,
      description: "Sobria pero con caracter",
      modalDescription: "En estos diseños tenemos una flor protagonista que tiene mucha presencia y da la elegancia que quizás estabas buscando. el Cymbidium es una orquídea que se sostiene muy bien en el tiempo, con el cuidado adecuado puede durar hasta un par de semanas. Esta acompañada de follajes elegantes que se adaptaran a la temporada pero sin perder la escencia del diseño. Desprenden buenos olores y no quitan el protagonismo de la orquídea. Los puedes obtener por separado o en grupo.",
      price: "Desde 40€",
      category: "eventos",
      imagenesSlider: [cymbidiumGrande, cymbidiumPequeno, cymbidiumVerde]
    },
    {
      id: 15,
      title: "Bienvenido Bebé",
      subtitle: "Pack de bienvenida grande",
      image: bebeGrande,
      description: "Pack de bienvenida grande",
      modalDescription: "La llegada de un bebé siempre ilusiona y emociona mucho. Incluye un ramo colorido de flores variadas que se puden sustituir según la temporada pero que nunca perderá la escencia de nuestros diseños. También incluye un jarrón desechable para que las flores esten siempre frescas y UNA MUSELINA para el nuevo bebé hecha a mano de doble gasa 100% algodón con certificado Oeko-Tex Standard 100.",
      price: "61€",
      category: "nacimientos",
      imagenesSlider: [bebeGrande, bebeGrandeModelo1, bebeGrandeModelo3, muselinaBebe]
    },
    {
      id: 16,
      title: "Bienvenido Bebé",
      subtitle: "Pack de bienvenida pequeño",
      image: bebePequeno,
      description: "Pack de bienvenida pequeño",
      modalDescription: "Incluye ramo colorido con flores que pueden ir variando según la temporada del año y una muselina para el bebé hipoalergénica hecha a mano de doble gasa 100% algodón con certificado Oeko-Tex Standard 100. Suave y totalmente respetuosa con pieles delicadas.",
      price: "47€",
      category: "nacimientos",
      imagenesSlider: [bebePequeno, bebePequenoModelo2, muselinaBebe]
    },
    {
      id: 17,
      title: "Velvet",
      subtitle: "Celebra el amor en cualquier ocasión",
      image: velvet,
      description: "Celebra el amor en cualquier ocasión",
      modalDescription: "Las Rosas de un rojo intenso son la flor principal de esta composición floral, este elegante diseño esta acompañado de distintos tipos de verdes que varian según la estación del año.",
      price: "45,50€",
      category: "romanticos",
      imagenesSlider: [velvet, velvetModelo1, velvetModelo2]
    },
    {
      id: 18,
      title: "Rosas blancas",
      subtitle: "Amor verdadero y eterno",
      image: rosaBlanca,
      description: "Amor verdadero y eterno",
      modalDescription: "Especialmente pensadas para bodas y compromisos.",
      price: "30€",
      category: "romanticos",
      imagenesSlider: [rosaBlanca, rosaBlancaModelo2, rosaBlancaModelo3, rosaBlancaModelo4]
    },
    {
      id: 19,
      title: "Rosas rojas",
      subtitle: "Amor apasionado y romántico",
      image: ramoRosas,
      description: "Amor apasionado y romántico",
      modalDescription: "Las más regaladas en aniversarios, San Valentín o para declarar amor. Incluye botella de cava ecológica.",
      price: "52.99€",
      category: "romanticos",
      imagenesSlider: [ramoRosas]
    },
    {
      id: 20,
      title: "Flores Secas",
      subtitle: "Perfecta en cualquier época del año",
      image: ramoSeco,
      description: "Perfecta en cualquier época del año",
      modalDescription: "Ramo seco de flores silvestres. El ramo que se realice siempre variará en flores y colores según la estación del año. Recuerda que trabajamos con material natural perecedero que vamos cambiando constantemente. No necesitan ningún  tipo de cuidado y pueden durar mucho tiempo. Para retirar el polvo solo hace falta pasar un plumero con delicadeza por encima de las hojas secas, el secador de pelo es otra buena opción, lo puedes utilizar a la mínima potencia con el aire frio, también muchas de vosotras nos habéis comentado que os funciona muy bien la laca para prevenir la cumulación del polvo. No os olvidéis que son materiales naturales muy delicados y con la exposición al sol acortamos su vida. Las flores silvestres que crean esta composición son cogidas y elegidas según la temporada del año en la que nos encontremos, esto quiere decir que las flores utilizadas no siempre serán las mismas.",
      price: "25€",
      category: "romanticos",
      imagenesSlider: [ramoSeco, ramoSecoPreservado]
    },
    {
      id: 21,
      title: "Orquídea Phalaenopsis",
      subtitle: "No incluye maceta",
      image: orquidea1,
      description: "No incluye maceta",
      modalDescription: "Si estas buscando otro tipo de planta contactanos o pásate por la tienda para elegir la que quieras. Tenemos una familia de plantas esperandote.",
      price: "25.83€",
      category: "plantas",
      imagenesSlider: [orquidea1, orquidea2]
    }
  ];

  // Filtrar proyectos según la categoría seleccionada
  const filteredProjects = projects.filter(project => project.category === selectedCategory);

  // Función para precargar imágenes
  const preloadImages = (imageUrls) => {
    return Promise.all(
      imageUrls.map((url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve; // Resolve even on error to avoid blocking
          img.src = url;
        });
      })
    );
  };

  const openModal = (project) => {
    setSelectedProject(project);
    setCurrentSlideIndex(0);
    
    // Track product view
    trackEvent('product_view', {
      product_name: project.title,
      product_category: project.category,
      product_price: project.price
    });
    
    // Precargar todas las imágenes del slider
    if (project.imagenesSlider && project.imagenesSlider.length > 1) {
      preloadImages(project.imagenesSlider);
    }
  };

  const closeModal = () => {
    setSelectedProject(null);
    setCurrentSlideIndex(0);
  };

  const nextSlide = () => {
    if (selectedProject && selectedProject.imagenesSlider) {
      setCurrentSlideIndex((prevIndex) => 
        (prevIndex + 1) % selectedProject.imagenesSlider.length
      );
    }
  };

  const prevSlide = () => {
    if (selectedProject && selectedProject.imagenesSlider) {
      setCurrentSlideIndex((prevIndex) => 
        prevIndex === 0 ? selectedProject.imagenesSlider.length - 1 : prevIndex - 1
      );
    }
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  // Detectar dirección del swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      nextSlide();
    } else if (isRightSwipe) {
      prevSlide();
    }
  };

  // Manejar click en la imagen
  const handleImageClick = (e) => {
    if (selectedProject && selectedProject.imagenesSlider && selectedProject.imagenesSlider.length > 1) {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const imageWidth = rect.width;
      
      // Si el click está en la mitad derecha, avanza; si está en la mitad izquierda, retrocede
      if (clickX > imageWidth / 2) {
        nextSlide();
      } else {
        prevSlide();
      }
    }
  };

  const handleGlovoLink = () => {
    // Track purchase intent
    trackEvent('purchase_intent', {
      product_name: selectedProject?.title,
      product_category: selectedProject?.category,
      product_price: selectedProject?.price,
      platform: 'glovo'
    });
    window.open('https://glovoapp.com/es/es/barcelona/stores/flores-de-lis-barcelona-barcelona', '_blank');
  };

  // Intersection Observer para detectar cuando las cards entran en pantalla
  const observerCallback = useCallback((entries) => {
    entries.forEach((entry) => {
      const itemId = entry.target.dataset.itemId;
      if (entry.isIntersecting) {
        setInViewItems(prev => new Set([...prev, itemId]));
      } else {
        setInViewItems(prev => {
          const newSet = new Set(prev);
          newSet.delete(itemId);
          return newSet;
        });
      }
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(observerCallback, {
      threshold: 0.3, // Activar cuando el 30% de la card esté visible
      rootMargin: '-50px 0px' // Margen para activar un poco después de entrar
    });

    // Observar todos los elementos gallery-item
    galleryItemsRef.current.forEach(item => {
      if (item) observer.observe(item);
    });

    return () => {
      galleryItemsRef.current.forEach(item => {
        if (item) observer.unobserve(item);
      });
    };
  }, [observerCallback, filteredProjects]);

  // Limpiar items cuando cambie la categoría
  useEffect(() => {
    setInViewItems(new Set());
    galleryItemsRef.current = [];
  }, [selectedCategory]);

  return (
    <section id="gallery" className="gallery">
      <div className="container">
        <h2>Flores</h2>
        <div className="gallery-intro">
          <p>
          <strong>¡Te lo llevamos a casa!</strong>
          </p>
          <p>
            <strong>Elige y reserva tu ramo</strong>. Nosotros nos encargamos de entregarlo. Si no encuentras lo que quieres podemos crear juntos un diseño especial para esa persona especial. 
          </p>
          
        </div>

        {/* Selector de tipología */}
        <div className="category-selector">
          {/* Versión desktop - botones */}
          <div className="category-buttons desktop-only">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => {
                  setSelectedCategory(category.id);
                  trackImageGalleryView(category.id);
                }}
              >
                {category.name}
              </button>
            ))}
          </div>
          
          {/* Versión móvil - dropdown */}
          <div className="category-dropdown mobile-only">
            <select 
              value={selectedCategory} 
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="category-select"
            >
              {categories.map(category => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className={`gallery-grid ${selectedCategory === 'plantas' ? 'gallery-grid-plantas' : ''}`}>
          {filteredProjects.map((project, index) => (
            <div 
              key={project.id} 
              ref={el => galleryItemsRef.current[index] = el}
              data-item-id={project.id}
              className={`gallery-item ${inViewItems.has(project.id.toString()) ? 'in-view' : ''} ${selectedCategory === 'plantas' ? 'gallery-item-planta' : ''}`}
              onClick={() => openModal(project)}
            >
              <img 
                src={project.image} 
                alt={project.title}
                loading="lazy"
              />
              <div className="gallery-overlay">
                <div>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <p className="price">{project.price}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedProject && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>
            <div className="modal-image">
              {selectedProject.imagenesSlider ? (
                <div className="image-slider">
                  <div 
                    className="slider-container"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                    onClick={handleImageClick}
                  >
                    <img 
                      src={selectedProject.imagenesSlider[currentSlideIndex]} 
                      alt={`${selectedProject.title} - Imagen ${currentSlideIndex + 1}`} 
                    />
                    
                    {selectedProject.imagenesSlider.length > 1 && (
                      <div className="slider-dots">
                        {selectedProject.imagenesSlider.map((_, index) => (
                          <button
                            key={index}
                            className={`dot ${index === currentSlideIndex ? 'active' : ''}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              goToSlide(index);
                            }}
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <img 
                  src={selectedProject.image} 
                  alt={selectedProject.title}
                />
              )}
            </div>
            <div className="modal-info centered-modal-info">
              <h3>{selectedProject.title}</h3>
              {selectedProject.subtitle && (
                <p className="modal-subtitle">{selectedProject.subtitle}</p>
              )}
              <p className="modal-description">
                {selectedProject.modalDescription || selectedProject.description}
              </p>
              <p className="modal-price">{selectedProject.price}</p>
              <button 
                className="glovo-button"
                onClick={handleGlovoLink}
              >
                Comprar en Glovo
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
